class SeeMoreToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-see-more-button]');
    this.visibleBlocks = parseInt(this.dataset.visibleBlocks) || 3;
    this.showText = this.dataset.showText || 'See more';
    this.hideText = this.dataset.hideText || 'See less';
    this.isExpanded = false;
  }

  connectedCallback() {
    if (!this.button) return;
    
    this.button.addEventListener('click', this.toggle.bind(this));
    this.updateVisibility();
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.toggle.bind(this));
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    this.updateVisibility();
    this.updateButtonText();
  }

  updateVisibility() {
    const rightSide = this.closest('.richtext__right-side');
    if (!rightSide) return;

    // Get all blocks except the see-more block itself
    const allBlocks = Array.from(rightSide.children).filter(child => child !== this);
    
    // Check if we need to show the button at all
    if (allBlocks.length <= this.visibleBlocks) {
      this.style.display = 'none';
      return;
    }
    
    // Show the see more button
    this.style.display = '';
    
    // Hide/show blocks after the visible count
    allBlocks.forEach((block, index) => {
      if (index >= this.visibleBlocks) {
        if (this.isExpanded) {
          block.style.display = '';
          block.classList.add('richtext-block--visible');
        } else {
          block.style.display = 'none';
          block.classList.remove('richtext-block--visible');
        }
      }
    });
  }

  updateButtonText() {
    if (this.button) {
      this.button.textContent = this.isExpanded ? this.hideText : this.showText;
    }
  }
}

customElements.define('see-more-toggle', SeeMoreToggle);